import { createFileRoute } from '@tanstack/react-router'

import { DigitalProductRanking } from '@/features/ranking'

export const Route = createFileRoute('/_event/ranking')({
  component: DigitalProductRankingPage
})

function DigitalProductRankingPage() {
  return <DigitalProductRanking />
}
